import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import classNames from 'classnames';
import { register } from '../i18n';

// remove manuscript when all components are built and manuscript items are removed from
// preview, graded and review modes
import '../css/Player.scss';
import '../css/Manuscript.scss';
import '../css/TestItems.scss';
import '../css/CkeditorContentStyles.scss';
import '../css/Accessibility.scss';

import useLessonInit from '../hooks/useLessonInit';

import { LessonMode } from '../Constants';
import InternetMessage from '../lessonPlayer/components/InternetMessage';

import BackgroundShade from '../lessonPlayer/layout/BackgroundShade';
import ContentLayout from '../lessonPlayer/layout/ContentLayout';
import FooterLayout from '../lessonPlayer/layout/FooterLayout';
import FullpageLoader from '../lessonPlayer/components/FullpageLoader';
import HiddenAudioPlayer from '../lessonPlayer/components/HiddenAudioPlayer';
import ToolbarLayout from '../lessonPlayer/layout/ToolbarLayout';
import AccessibilityAnnouncer from '../lessonPlayer/components/AccessibilityAnnouncer';

const t = register('AriaLabels');

const ItemPreview = observer(() => {
  const {
    lessonManager,
    toolbarManager,
  } = useContext(MobXProviderContext);

  useLessonInit(LessonMode.ITEM_PREVIEW);

  useEffect(() => {
    const className = `${LessonMode.PREVIEW} theme-override item-preview`;
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('class', className);
  });

  return (
    <>
      <AccessibilityAnnouncer />
      {/* eslint-disable-next-line no-nested-ternary */}
      {(lessonManager.isOnline && lessonManager.isLoaded && ((lessonManager.themeLoaded && lessonManager.translationsLoaded) || lessonManager.hasNoTheme)) ? (
        <div className={classNames('lesson-window', 'item-preview', { highlightOn: toolbarManager.isHighlightOrStickyToolOn })}>
          <BackgroundShade>
            {/* leave commented. Implement if we want a more robust viewer in the future */}
            <HiddenAudioPlayer />
            <header aria-label={t('mainMenu')} role='navigation'>
              <ToolbarLayout />
            </header>
            <main role='main'>
              <ContentLayout />
            </main>
            <nav aria-label={t('footer')}>
              <FooterLayout />
            </nav>
          </BackgroundShade>
        </div>
      ) : (!lessonManager.isOnline) ?
        (
          <InternetMessage />
        )
        : (
          <FullpageLoader />
        )}
    </>
  );
});
export default ItemPreview;
